import { useQuery } from '@tanstack/react-query'

import api from '../../api'

const useUserPermissions = (userEmail: string, enabled = true) => {
	return useQuery({
		queryKey: ['userPermissions', userEmail],
		queryFn: () => api.accessManagement.getUserPermissions(userEmail),
		enabled,
		select(data) {
			const response = data.body[0]
			return response
		}
	})
}

export default useUserPermissions
